import { Box } from '@chakra-ui/react'
import { EditedProps } from '@components/EditHeader'
import { FormElement } from '@components/forms/Input'
import { DotPhraseTemplate } from '@hb/shared'
import { dotPhraseTemplateField } from './fields'

export const DotPhraseTemplateBody = ({ expanded }: EditedProps<DotPhraseTemplate>) =>
  expanded ? (
    <Box w="100%" p={4}>
      <FormElement active name="" field={dotPhraseTemplateField} />
    </Box>
  ) : null
